<template>
  <a class="header__actions-link" :href="link" :title="title">
    <img class="header__actions-icon"
         :src="currentImage"
         alt="{{ title }}"
         v-on:mouseover="handleHover"
         v-on:mouseleave="handleLeave">
    <span class="header__actions-link-label">
        {{ amountComparedProducts }}
    </span>
  </a>
</template>

<script>
export default {
  name: "HeaderCompareProducts",
  props: [
      'link',
      'title',
      'image_icon',
      'image_hovered_icon'
  ],
  computed: {
    amountComparedProducts() {
      return this.$store.state.comparedProducts.length || 0;
    },
  },
  data() {
    return {
      currentImage: this.image_icon,
      hoverImage: this.image_hovered_icon,
      unhoveredImage: this.image_icon,
    };
  },
  methods: {
    handleHover() {
      this.currentImage = this.hoverImage;
    },
    handleLeave() {
      this.currentImage = this.unhoveredImage;
    }
  }
}
</script>